import Grid from './Grid'

export default Grid('container')
